const boxShadow = {}

boxShadow.hover = "0 -1rem 1rem #00000040 inset, 0 1rem 1rem #ffffff20 inset"
boxShadow.active = "0 1rem 1rem #00000040 inset, 0 -1rem 1rem #ffffff20 inset"

export default boxShadow